import { useState } from "react";
import { Copy, Loader2, Navigation } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { copyRouteUrl } from "@/lib/navigation-url";

export function GoogleRouteButton({ url, label }: { url: string; label: string }) {
  const [opening, setOpening] = useState(false);
  const [showCopy, setShowCopy] = useState(false);

  function openRoute() {
    setOpening(true);
    setShowCopy(false);
    const opened = window.open(url, "_blank", "noopener,noreferrer");
    window.setTimeout(() => {
      setOpening(false);
      if (!opened) {
        setShowCopy(true);
        toast.info("O navegador bloqueou a nova janela. A abrir o percurso nesta página…");
        window.location.assign(url);
      }
    }, 350);
  }

  return (
    <div className="flex flex-wrap gap-1.5">
      <Button type="button" variant="outline" size="sm" disabled={opening} onClick={openRoute} className="h-7 gap-1 border-brand/40 bg-brand/5 px-3 text-xs text-brand hover:bg-brand/10">
        {opening ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Navigation className="h-3.5 w-3.5" />}
        {label}
      </Button>
      {showCopy && (
        <Button type="button" variant="ghost" size="sm" className="h-7 gap-1 px-2 text-xs" onClick={async () => {
          const copied = await copyRouteUrl(url);
          toast[copied ? "success" : "error"](copied ? "Ligação do percurso copiada." : "Não foi possível copiar a ligação.");
        }}>
          <Copy className="h-3.5 w-3.5" /> Copiar ligação
        </Button>
      )}
    </div>
  );
}